<template>
  <div>
    <div class="elasticBlockStoreResourceGcp-title">
      <div>{{ $t("RAM.AWS.ElasticBlockStorage.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:elasticBlockStoreResourceGcp:update'
          ]"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:elasticBlockStoreResourceGcp:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="elasticBlockStoreResourceGcp-top">
      <elastic-block-store-resource-gcp-search
        ref="elasticBlockStoreResourceGcpSearchChild"
      ></elastic-block-store-resource-gcp-search>
    </div>
    <table-elastic-block-store-resource-gcp></table-elastic-block-store-resource-gcp>
  </div>
</template>

<script>
import ElasticBlockStoreResourceGcpSearch from "../ebs/ElasticBlockStoreResourceGcpSearch";
import TableElasticBlockStoreResourceGcp from "../ebs/TableElasticBlockStoreResourceGcp";

export default {
  name: "ElasticBlockStoreResourceGcp",
  components: {
    ElasticBlockStoreResourceGcpSearch,
    TableElasticBlockStoreResourceGcp
  },
  data() {
    return {
      modal_loading: false,
      accountNameSearchID: "",
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.companyId = this.$refs.elasticBlockStoreResourceGcpSearchChild.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 3,
          accountType: 4
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.companyId = this.$refs.elasticBlockStoreResourceGcpSearchChild.companyId;
      this.accountIds = this.$refs.elasticBlockStoreResourceGcpSearchChild.accountIds;
      this.volumeAwsId = this.$refs.elasticBlockStoreResourceGcpSearchChild.volumeAwsId;
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportGcpDisk({
          // "accountName": this.accountNameSearchID,
          companyId: this.companyId,
          accountIds: this.accountIdList,
          volumeAwsId: this.volumeAwsId
        })
        .then(res => {
          let fileName = this.$t('RAM.export.elasticBlockStorage');
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.elasticBlockStoreResourceGcp-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.elasticBlockStoreResourceGcp-title > div:nth-child(1) {
  float: left;
}
.elasticBlockStoreResourceGcp-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.elasticBlockStoreResourceGcp-top {
  width: 100%;
  height: 53px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/ebs/ElasticBlockStoreResourceGcp.vue